import { useEffect, useState } from 'react'

const QUERY = '(min-width: 1200px)'

/** Drives the structural switch between the mobile tabbed layout and the desktop two-column
 *  continuous-scroll layout (see App.tsx) - a JS-level decision, not just CSS, because the two
 *  layouts render different DOM structure (tabs + one visible section vs. everything stacked with
 *  an anchor nav), not just different styling of the same markup. */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => (typeof window === 'undefined' ? false : !window.matchMedia(QUERY).matches))

  useEffect(() => {
    const mql = window.matchMedia(QUERY)
    const onChange = () => setIsMobile(!mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
